/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Canceldesc2Inputs */

const zh_adminsubs_canceldesc2 = /** @type {(inputs: Adminsubs_Canceldesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择取消方式。立即取消将马上终止订阅，到期取消将在当前计费周期结束后终止。`)
};

const en_adminsubs_canceldesc2 = /** @type {(inputs: Adminsubs_Canceldesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how to cancel. Immediate cancellation terminates the subscription now. Cancel at period end will terminate it at the end of the current billing cycle.`)
};

const es_adminsubs_canceldesc2 = /** @type {(inputs: Adminsubs_Canceldesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija cómo cancelar. La cancelación inmediata termina la suscripción ahora. Cancelar al final del período la terminará al final del ciclo de facturación actual.`)
};

/**
* | output |
* | --- |
* | "Choose how to cancel. Immediate cancellation terminates the subscription now. Cancel at period end will terminate it at the end of the current billing cycle." |
*
* @param {Adminsubs_Canceldesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_canceldesc2 = /** @type {((inputs?: Adminsubs_Canceldesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Canceldesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_canceldesc2(inputs)
	if (locale === "en") return en_adminsubs_canceldesc2(inputs)
	return es_adminsubs_canceldesc2(inputs)
});
export { adminsubs_canceldesc2 as "adminSubs_cancelDesc" }